export default "__VITE_ASSET__DVzELT3P__"